export const MOBILE_QUERY = "@media (max-width:599.95px)";
